// LoadingScreen.js
import React, { useState, useEffect } from "react";
import logo from "../../Images/japl-logo.png";

const LoadingScreen = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let interval; 
    const load = () => {
      let width = 0;
      const interval = setInterval(() => {
        width += 1;
        setProgress(width);
        if (width >= 100) clearInterval(interval);
      }, 10);
    };
    
    load();
    
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1500);

    return () => {
      clearTimeout(timer);
      clearInterval(interval);
    };
  }, []);

  if (isLoading) {
    return (
      <div className="loading-screen fixed inset-0 flex flex-col items-center justify-center z-50 bg-gradient-to-r from-indigo-600 via-blue-500 to-purple-500 animate-gradient-x">
        {/* Logo Container with animations */}
        <div className="relative group mb-8">
          <div className="absolute -inset-2 bg-white/30 rounded-full blur-xl opacity-75 group-hover:opacity-100 transition-opacity duration-300 animate-pulse"></div>
          <img 
            src={logo} 
            alt="Logo" 
            className="w-full h-64 object-contain transform transition-transform duration-300 group-hover:scale-105 animate-fade-in" 
          />
        </div>

        {/* Progress Bar */}
        <div className="w-64 h-2.5 bg-gray-100/30 rounded-full overflow-hidden">
          <div 
            className="h-full bg-white transition-all duration-1500 ease-out" 
            style={{ width: `${progress}%` }}
          />
        </div>

        {/* Animated Loading Text */}
        <div className="mt-6 flex items-center space-x-2">
          <span className="text-white font-medium text-lg">Loading</span>
          <div className="flex space-x-1">
            {[...Array(3)].map((_, i) => (
              <div 
                key={i}
                className="w-1.5 h-1.5 bg-white rounded-full animate-bounce"
                style={{ animationDelay: `${i * 0.2}s` }}
              />
            ))}
          </div>
        </div>

        {/* Subtle Particle Animation */}
        <div className="absolute inset-0 pointer-events-none">
          {[...Array(20)].map((_, i) => (
            <div
              key={i}
              className="absolute w-1 h-1 bg-white/50 rounded-full"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animation: `float ${3 + Math.random() * 3}s infinite`
              }}
            />
          ))}
        </div>
      </div>
    );
  }

  return null;
};

export default LoadingScreen;

// Add these keyframes to your global CSS or use Tailwind's @layer directive
// @keyframes gradient-x {
//   0% { background-position: 0% 50% }
//   50% { background-position: 100% 50% }
//   100% { background-position: 0% 50% }
// }

// @keyframes float {
//   0%, 100% { transform: translateY(0) }
//   50% { transform: translateY(-20px) }
// }